function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import { isFunction } from "../../types/function";
import * as React from 'react';
import { useCallback } from 'react';
import { RippleEffect, RippleSurface } from "./styles";
import { useRipples } from "./useRipples";

/**
 * `withRipple` HOC adds the ripple effect to the component.
 *
 * It has a few requirements:
 * - `EnhancedComponent` should respect `className` and `onClick` props
 * - `EnhancedComponent` should have `children` prop
 * - `withRipple` HOC adds `overflow: hidden` and `position: relative` to the component
 *
 * @param {*} EnhancedComponent
 * @returns `EnhancedComponent` with ripple effect
 */
function withRipple(EnhancedComponent) {
  function RippleContainer({
    children,
    onClick,
    rippleColor,
    ...restProps })
  {
    const { ripples, addRippleEffect, removeRippleEffect } = useRipples();

    const handleClick = useCallback(
    (event) => {
      const { currentTarget } = event;

      const size = Math.max(currentTarget.offsetWidth, currentTarget.offsetHeight);
      const elementPosition = currentTarget.getBoundingClientRect();

      addRippleEffect({
        x: event.clientX - elementPosition.left - size / 2,
        y: event.clientY - elementPosition.top - size / 2,
        size });


      if (isFunction(onClick)) {
        onClick(event);
      }
    },
    [addRippleEffect, onClick]);


    return /*#__PURE__*/(
      React.createElement(RippleSurface, _extends({ as: EnhancedComponent, onClick: handleClick }, restProps),
      children,
      Object.keys(ripples).map((key) => /*#__PURE__*/
      React.createElement(RippleEffect, {
        key: key,
        size: ripples[key].size,
        x: ripples[key].x,
        y: ripples[key].y,
        color: rippleColor,
        onAnimationEnd: () => {
          removeRippleEffect(key);
        } }))));




  }

  return RippleContainer;
}

export default withRipple;